import styled from 'styled-components';

import { colors, fontSizes, fontWeights } from '../../theme';
import ButtonPrimitive from '../Button/ButtonPrimitive';

export const PaginationContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  white-space: nowrap;
  user-select: none;
`;

export const PaginationText = styled.p`
  color: ${colors.pigeon};
  font-weight: ${fontWeights.regular};
  font-size: ${fontSizes.xs};
  text-align: center;
`;

export const ArrowIcon = styled(ButtonPrimitive)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border-radius: 50%;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};

  svg {
    height: 24px;
    width: 24px;
  }

  &:hover {
    background-color: ${({ disabled }) => !disabled && colors.sand};
  }

  /* TODO Update focus styles when the design is ready */
  &:focus-visible {
    outline: 1px solid ${colors.mouse};
    box-shadow: 0 0 0 1px ${colors.sand};
  }
`;
